export default __webpack_public_path__ + "static/header-bg-x-repeat-5aa56c5e78b0cd3d5d57037f3316b104.jpg";